module.exports = __webpack_public_path__ + "static/img/aheader.8537c10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/aheader.png
// module id = 48
// module chunks = 0